import * as React from 'react';
import { SVGProps } from 'react';
const SvgHidePasswordIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.317 6.852a8.731 8.731 0 0 0-1.705 3.15 8.754 8.754 0 0 0 10.773 5.919M5.19 5.19A8.754 8.754 0 0 1 18.388 10a8.768 8.768 0 0 1-3.578 4.81M5.19 5.19 2.5 2.5m2.69 2.69 3.042 3.042m6.578 6.578 2.69 2.69m-2.69-2.69-3.042-3.042m0 0a2.5 2.5 0 1 0-3.535-3.536m3.535 3.536L8.232 8.232"
    />
  </svg>
);
export default SvgHidePasswordIcon;
